module.exports = __webpack_public_path__ + "img/time-funnel_blue.e4192aaf.png";